import type MonthYear from "src/interfaces/monthYear.interface";

export type Dispatcher = "manual" | "auto";

export type ErrorSyncStatusCode =
  | "unknown"
  | "user-not-logged-in"
  | "install-extension"
  | "update-extension";

export type SyncStatus =
  | undefined
  | {
      type: "error";
      message: string;
      dispatcher?: Dispatcher;
      code?: ErrorSyncStatusCode;
    }
  | {
      type: "syncing";
      step?: string;
      description?: string;
    }
  | {
      type: "locked";
      message: string;
    }
  | {
      type: "resume";
      message: string;
      job: "sales-import" | "inventory-import";
      integrationId: string;
      start?: MonthYear;
      end?: MonthYear;
    };

export type ResumeSyncStatus = Extract<
  Exclude<SyncStatus, undefined>,
  { type: "resume" }
>;

export function isResumeSyncStatus(
  status: SyncStatus
): status is ResumeSyncStatus {
  return !!status && status.type === "resume";
}

export interface IntegrationSyncState {
  mercari?: SyncStatus;
  poshmark?: SyncStatus;
  whatnot?: SyncStatus;
  vinted?: SyncStatus;
  depop?: SyncStatus;
}

export type IntegrationType = keyof IntegrationSyncState;

export interface SyncStatusAction {
  integration: IntegrationType;
  status: SyncStatus;
}

export type IsRunningKey = "inventoryIsRunning" | "salesIsRunning";
